import type { ReactNode } from "react";
import { SiteNav } from "./nav";
import { SiteFooter } from "./footer";
import { ChatWidget } from "./chat-widget";
import { ScrollProgress } from "./scroll-progress";

export function SiteLayout({ children, hideChat }: { children: ReactNode; hideChat?: boolean }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <ScrollProgress />
      <SiteNav />
      <main>{children}</main>
      <SiteFooter />
      {!hideChat && <ChatWidget />}
    </div>
  );
}